<template>
  <div v-if="isAuth" class="col-12 charge-wallet-1">

    <!--    <history-wallet class="d-inline-block mx-3" :user_id="user.id"/>-->

    <div class="mx-auto col-lg-5 col-12">
      <form @submit.prevent="onSubmit">

        <div class="form-group">
          <label v-t="`wallet.wallet_charge.price_label`"></label>
          <input class="form-control text-left" dir="ltr" v-model="form.value"/>
          <p class="mt-2 text-left" v-if="form.value > 0"

             v-html="$t('price.price',{currency:formatNumber(form.value)})"
          ></p>
          <form-errors-manager class="mt-2" :validation="v$.form.value"/>
        </div>


        <div class="my-3 p-2 bg-light">
          <h4 class="mb-3" v-t="`wallet.wallet_charge.gateway_title`"></h4>
          <gate-manager1 :charge-wallet="true" v-model="form.gateway"/>
          <form-errors-manager class="mt-2" :validation="v$.form.gateway"/>
        </div>


        <div class="mx-auto text-center">
          <button type="submit" class="w-50 btn btn-primary rounded-pill"
                  v-t="`wallet.wallet_charge.submit_button`"
          ></button>
        </div>


      </form>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {useVuelidate} from '@vuelidate/core'
import {required, numeric} from '@vuelidate/validators'
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {formatNumber, walletValue} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import GateManager1 from "../../Gate/GateManager/GateManager1.vue";


export default {
  name: "ChargeWallet1",
  components: {
    GateManager1,
    FormErrorsManager,
  },
  setup: () => ({v$: useVuelidate()}),
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
      profile: "User/getProfile"
    }),
  },
  data() {
    return {
      form: {
        value: '',
        description: '',
        transactionType: '',
        user_id: '',
        gateway: '',
      },
      user: {}
    }
  },
  validations() {
    return {
      form: {
        value: {required, numeric},
        gateway: {required}
      },
    }
  },
  methods: {
    async onSubmit() {
      const result = await this.v$.form.$validate()
      if (!result) return
      this.form['user_id'] = this.profile.id

      await this.$store.dispatch('Wallet/userChargeWallet', this.form)
    },
    formatNumber,
    walletValue,
  },
  mounted() {
  },
}
</script>

<style scoped>

</style>